<template>
  <div id="prescriber">
    <h2>{{ $t('pages.manager.edit') }}</h2>
    <p class="address-for-qr">{{ $t('pages.manager.address_for_qr') }}</p>
    <b-container>
      <ajax-edit
        :name="name"
        :uri="uri"
        :id="id"
        :additionnal-route="additionnalRoute"
        :config="{ headers: { 'Content-Language': $translation.getLocale() } }"
        :default-model-values="{
          'address': {
            'country': null,
            'street': null,
            'street_comp': null,
            'zip_code': null,
            'city': null
          }
        }"
        :fields-filter-list="parametersNotCompleted ? ['email'] : []"
      />
    </b-container>
  </div>
</template>

<script>
  import AjaxEdit from '@triotech/vue-core/src/components/ajax/AjaxEdit';

  export default {
    name: 'ManagerEdit',
    components: {
      AjaxEdit,
    },
    data() {
      return {
        id: this.user().id,
        name: 'manager',
        uri: 'api/manager',
        additionnalRoute: 'infos',
      };
    },
    computed: {
      parametersNotCompleted() {
        if (this.oauth()) {
          const paymentStep = (
            this.user().memorial
            && _.size(this.user().memorial.subscriptions) === 0
            && this.user().memorial.promo_code === null
          );
          const lolStep = (
            this.user().memorial
            && !this.user().memorial.currency
          );
          return !this.user().last_name || lolStep || paymentStep;
        }

        return false;
      },
    },
    mounted() {
      if (!this.user().last_name || this.user().roles[0] === 'ROLE_ADMIN') {
        this.$bus.$once(`t-event.edit-submit.${this.name}.success`, () => {
          this.$ajax.refresh().then(() => {
            this.$parent.step += 1;
          });
        });
      }

      this.$bus.$on('t-event.ajax-edit.manager.loaded', () => {
        window.$('.address-for-qr').prependTo(window.$('#manager_infos\\.address_street').closest('.form-group'));
        window.$('.address-for-qr').css('display', 'block');
      });
    },
  };
</script>

<style lang="scss" scoped>
  p.address-for-qr {
    display: none;
    font-size: 0.75em;
  }
</style>



// WEBPACK FOOTER //
// src/views/Manager/edit.vue